module.exports = __webpack_public_path__ + "img/cookie_option_saba.3c64f5b8.svg";